export default "__VITE_PUBLIC_ASSET__e9da8d22__"